import { t } from "@/i18n-js/instance";

import { SignedIdImageDropzone } from "./SignedIdImageDropzone";

export const CardViewThumbnailDropzone = () => (
  <SignedIdImageDropzone
    fieldName="cardview_thumbnail"
    uploadFieldName="cardview_thumbnail"
    fileLabel={t("cardview_thumbnail")}
    title={t("upload_a_cardview_thumbnail")}
    testId="quick-post-v3-cardview-thumbnail-dropzone"
  />
);
